module.exports = __webpack_public_path__ + "audioonly-silhouette.d09236e38e26b5fafc37.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/opentok/audioonly-silhouette.svg
// module id = ./src/assets/opentok/audioonly-silhouette.svg
// module chunks = 2